import { LogLevel } from 'ia-react-core/~/interfaces/LogLevel';
import addApi from '../api/#addApi';
import setSetting, { SetSettingOptions } from '../settings/#setSetting';
import removeSetting, { RemoveSettingOptions } from '../settings/#removeSetting';

const setLoggerApi = () => {
  const setLogLevels = (logLevels: LogLevel, options: SetSettingOptions) => {
    setSetting('logLevels', logLevels, options);
  };

  const clearLogLevels = (options: RemoveSettingOptions) => {
    removeSetting('logLevels', options);
  };

  addApi('setLogLevels', setLogLevels);
  addApi('clearLogLevels', clearLogLevels);
};

export default setLoggerApi;
